import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const withAuthProtection = (WrappedComponent, requireSubscription = false) => {
  const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const loggedIn = useSelector((state) => state.user.loggedIn);
    const isSubscribed = useSelector((state) => state.user.isSubscribed);

    React.useEffect(() => {
      if (!loggedIn) {
        // Store the attempted URL for redirect after login
        navigate('/signin', { 
          state: { from: location.pathname },
          replace: true 
        });
        return;
      }

      if (requireSubscription && !isSubscribed) {
        navigate('/pricing', { replace: true });
        return;
      }
    }, [loggedIn, isSubscribed, navigate, location]);

    // Show nothing while checking auth status
    if (!loggedIn || (requireSubscription && !isSubscribed)) {
      return null;
    }

    // Render the protected component if authenticated
    return <WrappedComponent {...props} />;
  };

  // Set display name for debugging
  ProtectedRoute.displayName = `withAuthProtection(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  
  return ProtectedRoute;
};

export default withAuthProtection;
